// removed by extract-text-webpack-plugin
module.exports = {"safetyPayResponse":"qempo_CheckoutAsyncCommon_safetyPayResponse-21ubTkg"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/new-order/CheckoutStep/components/CheckoutAsyncResponse/CheckoutAsyncCommon.scss
// module id = 651
// module chunks = 0